module.exports = __webpack_public_path__ + "img/app_store_icon.c9f243c5.png";